<mat-card class="order-medicine-create-view">
    <mat-card-title>
        New order medicine
    </mat-card-title>
    
    <div class="add-medicine-container">
        <core-add-order-medicine (onMedicineAdd)="addOrderItem($event)"></core-add-order-medicine>
    </div>
</mat-card>